import React from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";

const ImagePersonalization = dynamic(() => import("../../../organisms/imagePersonalization"), {
  ssr: false,
});

/**
 * MultiImageWithTextPersonalization component for rendering image personalization options.
 *
 * @component
 * @param {Object} props - Component properties.
 * @param {Array} props.personalizedOptions - Array of personalization options.
 * @param {boolean} props.isMobile - Flag indicating if the component is being viewed on a mobile device.
 * @param {string} props.productId - The ID of the product being personalized.
 * @returns {JSX.Element} The rendered component.
 */
const MultiImageWithTextPersonalization = ({ personalizedOptions, isMobile, productId, drawerProps }) => {
  /**
   * Renders JSX for image personalization options.
   *
   * @returns {JSX.Element[]} Array of JSX elements for image personalization.
   */
  const renderJsx = () => {
    return personalizedOptions?.map((option, index) => {
      if (option?.contentType === "IMAGE" || option?.contentType === "AUDIO") {
        return (
          <ImagePersonalization
            key={index}
            item={option}
            productId={productId}
            isMobile={isMobile}
            imageWithText={true}
            personalizedOptions={personalizedOptions}
            drawerProps={drawerProps}
          />
        );
      }
      return null;
    });
  };

  return <>{renderJsx()}</>;
};

MultiImageWithTextPersonalization.propTypes = {
  personalizedOptions: PropTypes.arrayOf(
    PropTypes.shape({
      contentType: PropTypes.string.isRequired,
      fieldName: PropTypes.string,
      allowedMediaType: PropTypes.string,
      label: PropTypes.string,
      maxInputRequired: PropTypes.string,
      minInputRequired: PropTypes.string,
      maxSize: PropTypes.string,
      minSize: PropTypes.string,
      required: PropTypes.string,
      sequenceNum: PropTypes.string,
    }),
  ).isRequired,
  isMobile: PropTypes.bool.isRequired,
  productId: PropTypes.string.isRequired,
  drawerProps: PropTypes.object,
};

export default MultiImageWithTextPersonalization;
